import { render, staticRenderFns } from "./IntegrationMessageList.vue?vue&type=template&id=3f09c298&"
import script from "./IntegrationMessageList.vue?vue&type=script&lang=js&"
export * from "./IntegrationMessageList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationMessageList.vue?vue&type=style&index=0&id=3f09c298&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports